import { epicRequest, reducersMerge, reduxFetchCreator, serverResponse } from 'app'
import System from 'system'
import { createSignature } from 'utils'

import type { ReportSchema } from '../../screens/Reports'

const getInitialState = () => serverResponse<undefined>()

const fetch = reduxFetchCreator<'reportFetch', ReportSchema, ReturnType<typeof getInitialState>>(
  'reportFetch',
  getInitialState(),
)

const fetchEpic = epicRequest({
  actionType: fetch.actions.reportFetch.type,
  errorAction: fetch.actions.reportFetchError,
  // @todo fix type
  fulfilledAction: fetch.actions.reportFetchFulfilled,
  request: ({ payload: { id, ...payload } }: { payload: ReportSchema }) => {
    window.open(
      `${System.api_url}/sports/tournament/${id}/report/csv?signature=${createSignature(
        JSON.stringify({
          ...payload,
          time: Date.now(),
        }),
      )}`,
    )
    return undefined
  },
  // @ts-ignore
  untilTypes: fetch.actions.reportFetchCancel.type,
})

export const actions = {
  ...fetch.actions,
}

export const epics = [fetchEpic]

export const reducer = reducersMerge(fetch.reducer) as typeof fetch.reducer
